

<div>
    Username: 
    <input type="text" name="username" [(ngModel)]="username">
    Password:
    <input type="text" name="password" [(ngModel)]="password">

    
    <button (click)="login();">Log In</button>
    <button (click)="signup();">Sign Up</button>
</div>